import { createSelector } from "reselect"

const getItems = props => props.items
const getOnly = props => props.onlyItem

export const getTotalItem = createSelector(
  [getItems],
  (items) =>
    items
      .filter(item => !item.disabled)
      .filter(item => item.id === "total"),
)

export const getBreakdownItems = createSelector(
  [getItems],
  (items) =>
    items
      .filter(item => !item.disabled)
      .filter(item => item.id !== "total"),
)

export const getOnlyLegendText = createSelector(
  [getOnly],
  (only) => only ? "All" : "Only",
)
